module.exports = __webpack_public_path__ + "static/media/furquan6.1e5f3406.png";